import * as yup from 'yup';
import { isValidCpf } from '~/utils/isValidCpf';

// Função para criar schema condicional baseado nos dados do insured
export const createValidationSchema = (
  insured?: {
    name?: string;
    social_name?: string;
    email?: string;
    mobile_phone?: string;
    document?: string;
    birthdate?: string;
  },
  requireAddress?: boolean
) => {
  return yup
    .object({
      socialName: yup
        .string()
        .max(64, 'Insira no máximo 64 caracteres')
        .test('is-valid-social-name', 'Insira apenas letras', (value) => {
          // Se o campo estiver vazio ou undefined, é válido
          if (!value || value.trim() === '') return true;
          // Se tiver conteúdo, valida se contém apenas letras
          return /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/.test(value);
        })
        .optional()
        .nullable(),
      fullName: insured?.name
        ? yup.string()
        : yup
            .string()
            .min(4, 'Insira no mínimo 4 caracteres')
            .max(64, 'Insira no máximo 64 caracteres')
            .matches(/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/, 'Insira apenas letras')
            .required()
            .test(`test-name-complete-length`, 'Digite o nome completo, este parece incompleto.', (value) => {
              if (
                value &&
                value
                  .trim()
                  .split(' ')
                  .filter((word) => word.length > 0).length > 1
              )
                return true;
              return false;
            }),
      email: insured?.email
        ? yup.string() // Se há dados do insured, campo não é obrigatório
        : yup.string().email('Email inválido').required('Email é obrigatório'),
      phone: insured?.mobile_phone
        ? yup.string() // Se há dados do insured, campo não é obrigatório
        : yup
            .string()
            .min(10, 'Número inválido')
            .required('Celular é obrigatório')
            .test(`test-phone-complete-length`, 'Digite o celular completo, este parece incompleto.', (value) => {
              if (value) {
                const newValue = value.replace(/\s/g, '');
                if (newValue.length > 13) return true;
              }
              return false;
            }),
      documentNumber: insured?.document
        ? yup.string() // Se há dados do insured, campo não é obrigatório
        : yup
            .string()
            .required('CPF é obrigatório')
            .test(`test-valid-cpf`, 'Digite um cpf válido.', (value) => {
              if (value) {
                return isValidCpf(value) ? true : false;
              }
              return false;
            }),
      birthDate: insured?.birthdate
        ? yup.string() // Se há dados do insured, campo não é obrigatório
        : yup
            .string()
            .required('Insira uma data de nascimento válida')
            .test(`test-valid-date`, 'Insira uma data de nascimento válida', (value) => {
              const cleanDate = value?.split('T')[0];

              function isUnderAge(date: Date) {
                var diff_ms = Date.now() - date.getTime();
                var age_dt = new Date(diff_ms);
                return Math.abs(age_dt.getUTCFullYear() - 1970) < 18;
              }

              if (cleanDate) {
                const year = new Date(cleanDate).getFullYear();
                const actualYear = new Date().getFullYear();
                if (year < 1900 || year > actualYear || isUnderAge(new Date(cleanDate))) return false;
              }

              return true;
            }),
      zipcode: requireAddress
        ? yup
            .string()
            .required('Este é um CEP inválido, digite um válido. Em caso de dúvidas, consulte o site dos Correios.')
            .test(
              `test-zipcode-length`,
              `Este é um CEP inválido, digite um válido. Em caso de dúvidas, 
        consulte o site dos Correios.`,
              (value) => {
                if (value) {
                  // Remove todos os caracteres não numéricos
                  const newValue = value.replace(/\D/g, '');
                  if (newValue.length === 8) return true;
                }
                return false;
              }
            )
        : yup.string().optional(),
      numberAddress: requireAddress
        ? yup.string().required('Digite o número para termos o seu endereço completo.').max(8, 'Máximo de 8 dígitos.')
        : yup.string().optional(),
      state: requireAddress
        ? yup.string().required('Estado é obrigatório.').max(2, 'Máximo de 2 caracteres.')
        : yup.string().optional(),
      city: requireAddress ? yup.string().required('Cidade é obrigatória.') : yup.string().optional(),
      neighborhood: requireAddress ? yup.string().required('Bairro é obrigatório.') : yup.string().optional(),
      street: requireAddress ? yup.string().required('Endereço é obrigatório.') : yup.string().optional(),
      additionalDetails: yup.string()
    })
    .required();
};
